import { BaseAuditableEntity } from '@domain';
import { QuoteItemTypeEnum } from '../../enums/quote-item-type.enum';
import { UnitOfMeasurementEnum } from '../../enums/unit-of-measurement.enum';

export class QuoteItemEntity extends BaseAuditableEntity {
    companyId: string;
    name: string;
    unitOfMeasurement: UnitOfMeasurementEnum;
    unitPrice: number;
    quantity: number;
    type: QuoteItemTypeEnum;

    // * Informa somente dentro do documento se o item foi inserido através do catálogo
    catalogItemId: string;
}
